/// <reference path='../../../../../typings/index.d.ts' />
/// <reference path="../../common/common.module.ts" />
/// <reference path='../controls.module.ts' />

module Meevo.Components.Controls {

    import ClientMembershipDataService = Meevo.Components.Common.ClientMembershipDataService;

    export interface ClientIndicator {
        key: number;
        order: number;
        className: string;
        visibleFields: string[];
        tooltip?: string;
        data?: any;
        alerts?: PassiveAlert[];
        clicked?: boolean;
        iconText?: string;
        clickable?: boolean;
        eligible?: boolean;
        peekColor?: string;
        peekClass?: string;
        iconWrapperStyles?: Record<string, string>;
        iconFile?: string[];
    }

    import ClientIndicatorEnum = Meevo.Model.ClientIndicatorEnum;
    import ClientMembershipIndicatorStatusEnum = Meevo.Model.ClientMembershipIndicatorStatusEnum;
    import PassiveAlert = Meevo.Plugins.AppointmentBook.PassiveAlert;
    import MembershipDetailsPart = Meevo.Components.Common.MembershipDetailsPart;
    import IPaymentPlanListItem = Meevo.Plugins.PaymentPlans.IPaymentPlanListItem;
    import ClientPaymentPlanStatusEnum = Meevo.Model.ClientPaymentPlanStatusEnum;

    export class MeevoClientIndicatorsController implements ng.IComponentController {
        $inject = [
            "appSettings",
            '$rootScope',
            '$scope',
            "$translate",
            "$filter",
            "$timeout",
            'meevo.components.common.ClientIndicatorsDataService',
            'meevo.components.common.MembershipDetailsService',
            'meevo.components.common.SecurityService',
            'meevo.components.common.ClientMembershipDataService',
            "meevo.components.common.IdentityService",
            'meevo.plugins.paymentPlans.PaymentPlansApi',
        ];

        public onIndicatorClick: () => {};
        public onCollapseClick: () => {};
        public onNoIndicatorsFound: () => {};
        public onChange: () => {};
        public hasAlert: () => {};
        peekEnabled: boolean;
        peekAlert: boolean;
        popups: boolean;
        collapseable: boolean;
        popupsLeftAlign: boolean;
        isCollapsed: boolean = false;
        clientId: string;
        client: any;
        notes: any;
        countOfActivePaymentPlans: number;
        paymentPlanId: string;

        indicators: ClientIndicator[];
        showAll: boolean;
        popupContainerStyleLeft: string;
        popupContainerStyleRight: string;
        popupContainerClass: string;
        selectedIndicators: number[] = [];
        detailClicked: number = 0;
        actionButtonText: string;
        canEditClientMembership: boolean;
        loadingClientId: string;
        tooltip_line_accountBalance: string;
        tooltip_line_accountSpendingLimit: string;
        tooltip_line_accountRemainingAvailableCredit: string;
        tooltip_line_existingCredit: string;

        securityKeys = Meevo.Components.Common.SecurityKeys;
        clientReadPermission: boolean = false;
        clientWritePermission: boolean = false;

        private filterNumber = this.$filter('number') as any;
        private filterCurrency = this.$filter('meevoCurrency') as any;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            private $rootScope: ng.IRootScopeService,
            private $scope: ng.IScope,
            private $translate: angular.translate.ITranslateService,
            private $filter: angular.IFilterService,
            private $timeout: angular.ITimeoutService,
            private dataService: Meevo.Components.Common.ClientIndicatorsDataService,
            private membershipDetailsService: Meevo.Components.Common.MembershipDetailsService,
            private securityService: Meevo.Components.Common.ISecurityService,
            private clientMembershipDataService: ClientMembershipDataService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private _paymentPlansApi: Meevo.Plugins.PaymentPlans.PaymentPlansApi) {
                //console.log("CLIENT INDICATORS COMPONENT CONSTRUCTOR", $scope);

                $scope.$on('$destroy', () => {
                    //console.log('=========CLIENT INDICATORS COMPONENT ONDESTROY======');
                    $(document).off("click", this.clickHandler);
                });

                $scope.$on(Meevo.Components.Common.Messages.RESET_INDICATORS, () => {
                    this.indicators = [];
                    this.getClientIndicators(false);
                });

            this.securityService.checkSecurityKey(this.securityKeys.DATA_CLIENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(result => {
                this.clientReadPermission = (result === Meevo.Model.SecurityAccessEnum.Grant);
            });
            this.securityService.checkSecurityKey(this.securityKeys.DATA_CLIENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE).then(result => {
                this.clientWritePermission = (result === Meevo.Model.SecurityAccessEnum.Grant);
            });
        }

        $onInit(): void {
            this.indicators = [];
            this.isCollapsed = false;
            this.getClientIndicators();

            $(document).on("click", this.clickHandler);

            if (this.haveMembershipData) {
                var clientMembershipEditKey = Meevo.Components.Common.SecurityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
                this.securityService.checkSecurityKey(clientMembershipEditKey).then(result => {
                    this.canEditClientMembership = result === Meevo.Model.SecurityAccessEnum.Grant;
                });

            }

            if (this.peekEnabled) {
                this.peekAlert = true;
            }
        }

        get indicatorData() : any {
            var indicator = this.dataService.CLIENT_INDICATORS[this.selectedIndicator.key];

            if (indicator.visibleFields && indicator.visibleFields.length > 0) {
                let returnableData = {};
                for (const key in indicator.visibleFields) {
                    let item = indicator.visibleFields[key];
                    let value = this.selectedIndicator.data[item];
                    if (Number(this.selectedIndicator.key) === ClientIndicatorEnum.ClientGiftCards && Number(value) === 0) {
                        continue;
                    }
                    returnableData[item.toUpperCase()] = value;
                }
                return returnableData;
            }
            return this.selectedIndicator.data;
        }

        get indicatorAlerts() : any {
            return this.selectedIndicator.alerts || [];
        }

        get selectedIndicator() : ClientIndicator {
            return this.indicators.filter(x => x.key == this.detailClicked)[0];
        }

        togglePeeks(e = null) : void {
            if (!this.peekEnabled) return;
            if (e) {
                e.stopPropagation();
            }

            this.peekAlert = !this.peekAlert;
        }

        getKeyLabel(key: string, value: string) {
            let conditionalKey = key;
            switch (Number(this.selectedIndicator.key)) {
                case ClientIndicatorEnum.ClientAccountBalance:
                    if (key == "ACCOUNTBALANCE") {
                        if (Number(value) > 0) {
                            conditionalKey = "EXISTINGCREDIT";
                        }
                    }
                    break;
                default:
                    break;
            }

            let keyToLookup = `CLIENT_INDICATOR_${this.selectedIndicator.key}_${conditionalKey.toUpperCase()}`;
            var translatedLabel = this.$translate.instant(keyToLookup);
            return translatedLabel !== keyToLookup ? translatedLabel : key;
        }

        getKeyValue(key: string, value: string) {
            key = key.toUpperCase();
            switch (Number(this.selectedIndicator.key)) {
                case ClientIndicatorEnum.ClientAccountBalance:
                    if (key == "ACCOUNTBALANCE" || key == "ACCOUNTSPENDINGLIMIT" || key == "REMAININGAVAILABLECREDIT") {
                        return this.filterCurrency(value);
                    }
                    break;
                case ClientIndicatorEnum.ClientPoints:
                    if (key == "REMAININGAMOUNT" || key == "REMAININGVALUE") {
                        return this.filterCurrency(value);
                    }
                case ClientIndicatorEnum.ClientMemberships:
                    if (key == "CLIENTMEMBERSHIPINDICATORSTATUS") {
                        let keyToLookup = `LABEL_TOOLTIP_MEMBERSHIP_${ClientMembershipIndicatorStatusEnum[value].toUpperCase()}`;
                        let translatedLabel = this.$translate.instant(keyToLookup);
                        return translatedLabel !== keyToLookup ? translatedLabel : key;
                    }
            }
            return value;
        }

        clickHandler = (e) => {
            var elements = $('[id^="client-indicator-"]');
            let found = false;
            for (let i = 0; i < elements.length; i++) {
                if (elements[i] == e.target || elements[i].childNodes[1] == e.target) {
                    found = true;
                }
            }

            if (!found) {
                this.$timeout(() => {
                    this.detailClicked = 0;
                });
            }
        }

        getPopupDataContainerClass() : string {
            switch (Number(this.selectedIndicator.key)) {
                case ClientIndicatorEnum.ClientAlerts:
                    return "client-alerts"
                default:
                    return null;
            }
        }

        getDynamicValueClass(key?: string): string {
            return `client-indicator-${Number(this.selectedIndicator.key)}-${key}`
        }

        indicatorClicked(event: Event, indicator: ClientIndicator) : void {
            event.stopPropagation();
            if (this.popups === false) {
                this.indicatorActionClicked(Number(indicator.key));
                return;
            }
            let keyToLookup = `CLIENT_INDICATOR_${indicator.key}_ACTIONTEXT`;
            let translatedText = this.$translate.instant(keyToLookup);
            this.actionButtonText = keyToLookup !== translatedText ? translatedText : null;

            var index = this.indicators.findIndex(x => x.key == indicator.key);

            if (this.popupsLeftAlign || this.indicators.length < 4 || (index == 0 || index < Math.round((this.indicators.length - 1) / 2))) {
                var leftPost = event.currentTarget["offsetLeft"] - event.currentTarget['offsetWidth'] - (this.peekEnabled ? 0 : 5);
                this.popupContainerStyleLeft = `${leftPost}px`;
                this.popupContainerStyleRight = 'unset';
                this.popupContainerClass = "";
            } else {
                var parentWidth = $(event.currentTarget).parent().parent().width();
                var rightPos = parentWidth - event.currentTarget["offsetLeft"] - 50;
                this.popupContainerStyleRight = `${rightPos}px`,
                this.popupContainerStyleLeft = 'unset';
                this.popupContainerClass = "right-aligned";
            }

            if (this.actionButtonText || (indicator.alerts && indicator.alerts.length > 0)) {
                this.detailClicked = indicator.key;
            } else {
                // no popup just call action
                this.indicatorActionClicked(Number(indicator.key));
            }
            $('.alertItems').hide();
        }

        indicatorRowClicked() : void {
            if (this.peekEnabled && this.peekAlert) {
                this.peekAlert = false;
            }
        }

        collapseIndicators() : void {
            this.$timeout(() => {
                this.onCollapseClick();
            });
        }

        isIndicatorSelected(key: string) : boolean {
            const item = ClientIndicatorEnum[key];
            return (this.showAll || this['show' + key.replace("Client", "")])
                && this['show' + key.replace("Client", "")] !== false
                && !isNaN(Number(item));
        }

        getClientIndicatorData(key: number, data: any) : any {
            return (key != ClientIndicatorEnum.ClientAlerts) ? data.indicators[key] : {};
        }

        getClientIndicatorAlerts(key: number, data: any) : any {
            if (key == ClientIndicatorEnum.ClientAlerts) {
                var alertData = [];
                for (const item in data.indicators[key]) {
                    var alert : any = {
                        alertPriorityLevel: Meevo.Model.AlertPriorityLevelEnum.Normal,
                        alertMessage: this.$translate.instant(`CLIENT_ALERT_${item.toUpperCase()}`),
                        alertClick: () => {
                            this.indicatorActionClicked(ClientIndicatorEnum.ClientAlerts, Meevo.Model.ClientAlertTypeEnum[item]);
                         }
                    }
                    alertData.push(alert);
                }
                return alertData;
            } else {
                return null;
            }
        }

        getClientIndicators(cache = true): void {
            if (!this.clientId) return;
            this.selectedIndicators = [];

            for (const key in ClientIndicatorEnum) {

                if (this.isIndicatorSelected(key)) {
                    this.selectedIndicators.push(Number(ClientIndicatorEnum[key]));
                }
            }
            //console.log('indicators to fetch', indicators);
            if (this.selectedIndicators.length > 0 && this.loadingClientId != this.clientId) {
                this.loadingClientId = this.clientId;
                this.dataService.getClientIndicatorsData(this.clientId, this.selectedIndicators, !this.client, cache).then((data: any) => {
                    //console.log('got client indicators', data)
                    this.loadingClientId = undefined;
                    if (!data || !data.indicators || data.indicators.length < 1) return;

                    if (data.client) {
                        this.client = data.client;
                    }

                    let isPaymentPlansIndicatorExist = data.indicators[ClientIndicatorEnum.ClientPaymentPlans];
                    if (isPaymentPlansIndicatorExist && isPaymentPlansIndicatorExist.ClientId) {
                       this.countOfActivePaymentPlans = isPaymentPlansIndicatorExist.Count;
                       this.getPaymentPlanData();
                    }

                    for (const key of this.selectedIndicators) {
                        let indicator = angular.copy(this.dataService.CLIENT_INDICATORS[key]) as ClientIndicator;
                        if (!indicator) {
                            continue;
                        }
                        indicator.key = key;
                        indicator.data = this.getClientIndicatorData(key, data);
                        indicator.alerts = this.getClientIndicatorAlerts(key, data);
                        indicator.iconWrapperStyles = {};

                        var conditionalClass = this.getConditionalIndicatorClass(indicator);
                        if (conditionalClass) {
                            indicator.className = `${indicator.className || ''} ${conditionalClass}`;
                        }
                        const backgroundUrl = this.getIndicatorBackgroundUrl(indicator);
                        if (backgroundUrl) {
                            indicator.iconWrapperStyles.background = `url(${backgroundUrl}) center center no-repeat`;
                        }
                        indicator.iconText = this.getIndicatorIconText(indicator);
                        indicator.tooltip = this.getConditionalTooltipText(indicator);
                        indicator.eligible = this.getIndicatorVisibility(indicator)
                        indicator.peekClass = this.getIndicatorPeekClass(indicator);
                        if (indicator.eligible || this.peekEnabled) {
                            let ndx = this.indicators.findIndex(x => x.key == indicator.key);
                            if (ndx > -1) {
                                this.indicators[ndx] = indicator;
                            } else {
                                this.indicators.push(indicator);
                            }
                        }
                    }
                    this.indicators = this.indicators.filter(indicator =>
                        !(indicator.key === ClientIndicatorEnum.ClientMemberships && indicator.data && indicator.data['ClientMembershipIndicatorEnum'] === undefined));
                    this.indicators.sort((a, b) => (a.order > b.order) ? 1 : -1);
                    //console.log('indicators created', this.indicators)
                    this.notifyOnChange();
                });
            }
        }

        notifyOnChange() {
            if (this.indicators.length === 0 && (!this.notes || this.notes.length === 0)) {
                this.onNoIndicatorsFound();
            } else {
                this.onChange();
            }
        }

        getIndicatorAnimationDelay(key) : string {
            return this.peekEnabled ? null : `{ 'animation-delay' : '${(key + 1) * 50}ms' }`;
        }

        get clientIndicators() : ClientIndicator[] {
            if (!this.indicators) return null;
            return this.indicators.filter(x => x.key != ClientIndicatorEnum.ClientType);
        }

        getConditionalIndicator(indicator: ClientIndicator) : any {
            switch (indicator.key) {
                case ClientIndicatorEnum.ClientType:
                    return {
                        color: indicator.data && indicator.data.Color ? `{'fill': '${this.clientTypeIndicator.data.Color}'}` : null,
                        icon: indicator.iconFile[0]
                    };
                case ClientIndicatorEnum.ClientPaymentAccounts:
                    let onlyExpiredCards = indicator.data && indicator.data["ExpiredAccounts"] > 0 && indicator.data["ActiveAccounts"] === 0;
                    return {
                        color: `{'fill': '${onlyExpiredCards ? '#eb3131' : '#a67df9'}'}`,
                        icon: indicator.iconFile[!onlyExpiredCards ? 0 : 1]
                    }
                default:
                    return {};
            }
        }

        getClientTypeIconColor() : string {
            if (this.clientTypeIndicator && this.clientTypeIndicator.data && this.clientTypeIndicator.data.Color) {
                return `{'fill': '${this.clientTypeIndicator.data.Color}'}`
            }
            return null;
        }

        getPaymentPlanData() {
            this._paymentPlansApi.getPaymentPlansList({
                clientId: this.clientId

            }).then((res: IPaymentPlanListItem[]) => {
                const activePaymentPlans = (res || []).filter(row => row.clientPaymentPlanStatusEnum === ClientPaymentPlanStatusEnum.Active);

                if (activePaymentPlans.length > 0) {
                    this.paymentPlanId = res[0].id;
                }
            })
        }

        indicatorActionClicked(key = 0, clientAlertType = undefined) : void {
            let indicatorKey = key > 0 ? key : Number(this.selectedIndicator.key);
            let idParam = this.clientId;
            let actionStateParam = Meevo.Model.MaintenanceFormState.Readonly;
            if (this.securityService.hasSecurity(this.securityKeys.DATA_CLIENT + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {

                let stateNameParam = this.appSettings.ROUTE_NAMES.client;
                let initialEditSectionParam = null;
                let initialEditSubSectionParam = null;
                let targetRouteParam = null;
                let clientDisplayNameParam = this.client ? this.client.DisplayName : null;
                let filterParam = null;
                let paymentPlanTargetRoute = `${this.appSettings.ROUTE_NAMES.paymentPlans}?clientId=${this.clientId}`;

                if (this.countOfActivePaymentPlans === 1) {
                    paymentPlanTargetRoute = `${this.appSettings.ROUTE_NAMES.paymentPlans}/${this.paymentPlanId}/main`;
                }

                switch (indicatorKey) {
                    case ClientIndicatorEnum.ClientAccountBalance:
                        initialEditSectionParam = "SECTION_HISTORY";
                        initialEditSubSectionParam = "ACCOUNT_HISTORY";
                        break;
                    case ClientIndicatorEnum.ClientCancelledOrNoShowAppt:
                        initialEditSectionParam = "SECTION_HISTORY";
                        initialEditSubSectionParam = "APPOINTMENT_HISTORY"
                        filterParam = Meevo.Plugins.Client.ClientAppointmentHistoryFilterType.NoShowAndCancelled;
                        break;
                    case ClientIndicatorEnum.ClientGiftCards:
                        initialEditSectionParam = "SECTION_HISTORY";
                        initialEditSubSectionParam = "GIFTCARD_HISTORY"
                        break;
                    case ClientIndicatorEnum.ClientMemberships:
                        stateNameParam = this.appSettings.ROUTE_NAMES.membershipManager;
                        idParam = this.selectedIndicator.data["ClientMembership_TId"];
                        if (!idParam) return;
                        if (this.canEditClientMembership) {
                            actionStateParam = Meevo.Model.MaintenanceFormState.Editing;
                        }
                        break;
                    case ClientIndicatorEnum.ClientPackages:
                        initialEditSectionParam = "SECTION_HISTORY";
                        initialEditSubSectionParam = "PACKAGE_HISTORY";
                        break;
                    case ClientIndicatorEnum.ClientPaymentPlans:
                        stateNameParam = this.appSettings.ROUTE_NAMES.paymentPlans;
                        targetRouteParam = paymentPlanTargetRoute;
                        break;
                    case ClientIndicatorEnum.ClientPoints:
                        stateNameParam = this.appSettings.ROUTE_NAMES.clientPoint;
                        break;
                    case ClientIndicatorEnum.ClientTransworld:
                        stateNameParam = this.appSettings.ROUTE_NAMES.membershipManager;
                        initialEditSectionParam = 'SECTION_MEMBERSHIPMANAGER_PAYMENTS';
                        if (this.haveMembershipData) {
                            var membershipData = this.indicators.filter(x => x.key == ClientIndicatorEnum.ClientMemberships);
                            if (!membershipData || membershipData.length == 0) return;
                            idParam = membershipData[0].data["ClientMembership_TId"];
                        } else {
                            return;
                        }
                        break;
                    case ClientIndicatorEnum.ClientPaymentAccounts:
                        initialEditSectionParam = "SECTION_CLIENT_CREDIT_CARD";
                        break;
                    case ClientIndicatorEnum.ClientAlerts:
                        if (this.clientReadPermission && this.clientWritePermission) {
                            actionStateParam = Meevo.Model.MaintenanceFormState.Editing;
                        }
                    default:
                        break;
                }

                this.$timeout(() => {
                    this.detailClicked = 0;
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                        stateName: stateNameParam,
                        stateParams: {
                            callback: null,
                            callbackState: null,
                            targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                            targetRoute: targetRouteParam,
                            actionState: actionStateParam,
                            initialEditSection: initialEditSectionParam,
                            initialEditSubSection: initialEditSubSectionParam,
                            id: idParam,
                            clientDisplayName: clientDisplayNameParam,
                            filter: filterParam
                        },
                        clientAlertType: clientAlertType
                    });
                })
                if (this.onIndicatorClick) {
                    this.onIndicatorClick();
                }
            }




        }

        get haveMembershipData() : boolean {
            return this.selectedIndicators.indexOf(ClientIndicatorEnum.ClientMemberships) > -1
        }

        getIndicatorVisibility(indicator: any) : boolean {
            if (!(indicator && (indicator.data || indicator.alerts))) return;
            switch (indicator.key) {
                case ClientIndicatorEnum.ClientAccountBalance:
                    return indicator.data.AccountBalance && indicator.data.AccountBalance != 0;
                case ClientIndicatorEnum.ClientGiftCards:
                    return indicator.data.GiftCard > 0;
                case ClientIndicatorEnum.ClientPackages:
                    return !this.identityService.inCentralOfficeMode() && (indicator.data.Package > 0 || indicator.data.UnlimitedPackage > 0);
                case ClientIndicatorEnum.ClientCancelledOrNoShowAppt:
                    return indicator.data.ClientCancelledOrNoShow > 0;
                case ClientIndicatorEnum.ClientPaymentPlans:
                    return indicator.data.Count > 0;
                case ClientIndicatorEnum.ClientTransworld:
                    return indicator.data.IsSentToTransworld;
                case ClientIndicatorEnum.ClientMinor:
                    return indicator.data.IsMinor;
                case ClientIndicatorEnum.ClientRestricted:
                    return indicator.data.IsRestricted;
                case ClientIndicatorEnum.ClientType:
                    return !!indicator.data.Id;
                case ClientIndicatorEnum.ClientPaymentAccounts:
                    return indicator.data.ActiveAccounts > 0 || indicator.data.ExpiredAccounts > 0;
                case ClientIndicatorEnum.ClientAlerts:
                    return indicator.alerts && indicator.alerts.length > 0;
                case ClientIndicatorEnum.ClientPoints:
                    return indicator.data.RemainingPoints > 0;
                default:
                    return true;
            }

        }

        getIndicatorSecurityKey(key) : string {
            if (!key) return;
            switch(key) {
                case ClientIndicatorEnum.ClientPoints:
                    return Meevo.Components.Common.SecurityKeys.MANAGEMENT_CLIENTPOINT_ACTION_CLIENTPOINTSINDICATOR;
                case ClientIndicatorEnum.ClientGiftCards:
                    return Meevo.Components.Common.SecurityKeys.DATA_GIFTCARDTYPE_ACTION_GIFTCARDLIABILITYINDICATOR;
                case ClientIndicatorEnum.ClientPackages:
                    return Meevo.Components.Common.SecurityKeys.DATA_PACKAGETYPE_ACTION_PACKAGELIABILITYINDICATOR;
                default:
                    return null;
            }
        }

        getIndicatorIconText(indicator: ClientIndicator) : string {
            switch (indicator.key) {
                case ClientIndicatorEnum.ClientAlerts:
                    return (indicator.alerts && indicator.alerts.length > 0) ? indicator.alerts.length.toString() : null;
                default:
                    return null;
            }
        }

        getIndicatorBackgroundUrl(indicator: ClientIndicator): string {
            switch (indicator.key) {
                case ClientIndicatorEnum.ClientMemberships:
                    if (indicator.data && typeof indicator.data.ClientMembershipIndicatorEnum === 'number') {
                        return this.clientMembershipDataService.getClientMembershipIndicatorEnumIcon(indicator.data.ClientMembershipIndicatorEnum);
                    }
                default:
                    return null;
            }
        }

        getConditionalIndicatorClass(indicator: ClientIndicator) : string {
            switch (indicator.key) {
                case ClientIndicatorEnum.ClientAccountBalance:
                    if (!indicator.data || !indicator.data['AccountBalance']) return null;
                    return indicator.data['AccountBalance'] > 0 ? 'clientaccountpositive' : (indicator.data['AccountBalance'] < 0) ? 'clientaccountnegative' : '';
                case ClientIndicatorEnum.ClientMemberships:
                    if (!indicator.data || !indicator.data['ClientMembershipIndicatorStatus']) return null;
                    return ClientMembershipIndicatorStatusEnum[indicator.data['ClientMembershipIndicatorStatus']].toLowerCase();
                case ClientIndicatorEnum.ClientPackages:
                    if (!indicator.data || angular.isUndefined(indicator.data['UnlimitedPackage'])) return null;
                    return indicator.data['UnlimitedPackage'] > 0 ? 'unlimitedPackage' : 'package';
                default:
                    return indicator.visibleFields === undefined ? 'unclickable' : null;
            }
        }

        get clientTypeIndicator() : ClientIndicator {
            // this <svg> must have its css fill property set to properly colorize on UI,
            // and can't be used as a background-image on div like other icons
            if (!this.indicators) return null;
            return this.indicators.filter(x => x.key == ClientIndicatorEnum.ClientType)[0];
        }

        isVariableColorIndicator(indicator: ClientIndicator) : boolean {
            if (!indicator) return false;
            return [ClientIndicatorEnum.ClientType, ClientIndicatorEnum.ClientPaymentAccounts].some(x => x == indicator.key);
        }

        getIndicatorPeekClass(indicator: ClientIndicator) : string {
            if (!indicator.eligible) return null;
            switch (indicator.key) {
                case ClientIndicatorEnum.ClientMemberships:
                    indicator.data.membershipIndicatorStatus = indicator.data.ClientMembershipIndicatorStatus;
                    return this.membershipDetailsService.getDetails(indicator.data, MembershipDetailsPart.ClassName) || null;
                default:
                    return null;
            }
        }

        getPeekStyle(indicator: ClientIndicator) : string {
            if (!indicator.eligible) return null;
            let color;
            switch (indicator.key) {
                case ClientIndicatorEnum.ClientPoints:
                    return "{'background-color': '#ffa502'}"
                case ClientIndicatorEnum.ClientGiftCards:
                    return "{'background-color': '#00b101'}"
                case ClientIndicatorEnum.ClientPackages:
                    return "{'background-color': '#0196ff'}"
                case ClientIndicatorEnum.ClientAccountBalance:
                    color = indicator.data['AccountBalance'] > 0 ? 'rgb(108, 235, 119)' : 'rgb(240, 108, 108)';
                    return `{'background-color': '${color}'}`;
                case ClientIndicatorEnum.ClientCancelledOrNoShowAppt:
                    return "{'background-color': '#FF0000'}"
                case ClientIndicatorEnum.ClientAlerts:
                    return "{'background-color': '#f59160'}"
                case ClientIndicatorEnum.ClientTransworld:
                    return "{'background-color': '#61B5E8'}"
                case ClientIndicatorEnum.ClientPaymentAccounts:
                    color = indicator.data['ActiveAccounts'] > 0 ? '#a67df9' : 'red';
                    return `{'background-color': '${color}'}`;
                case ClientIndicatorEnum.ClientPaymentPlans:
                    return "{'background-color': '#926BF2'}"
                case ClientIndicatorEnum.ClientType:
                    if (this.clientTypeIndicator && this.clientTypeIndicator.data) {
                        return `{'background-color': '${this.clientTypeIndicator.data.Color}'}`;
                    }
                    return null;
                default:
                    return null;
            }

        }

        getLocationName(): string {
            if (!this.selectedIndicator || !this.selectedIndicator.data) return null;
            return this.selectedIndicator.key == ClientIndicatorEnum.ClientMemberships ? this.selectedIndicator.data.HomeLocationName : null;
        }

        getConditionalTooltipText(indicator: any) : string {
            if (!indicator.data && !indicator.alerts) return null;
            switch (indicator.key) {
                case ClientIndicatorEnum.ClientAccountBalance:
                    this.tooltip_line_accountBalance = `${this.$translate.instant('CLIENT_INDICATOR_11045434_ACCOUNTBALANCE')}: ${this.filterCurrency(indicator.data.AccountBalance)}`;
                    this.tooltip_line_existingCredit = `${this.$translate.instant('CLIENT_INDICATOR_11045434_EXISTINGCREDIT')}: ${this.filterCurrency(indicator.data.AccountBalance)}`;
                    this.tooltip_line_accountSpendingLimit = `${this.$translate.instant('CLIENT_INDICATOR_11045434_ACCOUNTSPENDINGLIMIT')}: ${this.filterCurrency(indicator.data.AccountSpendingLimit)}`;
                    this.tooltip_line_accountRemainingAvailableCredit = `${this.$translate.instant(`CLIENT_INDICATOR_11045434_REMAININGAVAILABLECREDIT`)}: ${this.filterCurrency(indicator.data.RemainingAvailableCredit)}`;

                    if (indicator.data.AccountBalance < 0) {
                        return `${this.tooltip_line_accountBalance} 
${this.tooltip_line_accountSpendingLimit} 
${this.tooltip_line_accountRemainingAvailableCredit}`
                    } else {
                        return `${this.tooltip_line_existingCredit} 
${this.tooltip_line_accountSpendingLimit} 
${this.tooltip_line_accountRemainingAvailableCredit}`
                    }
                case ClientIndicatorEnum.ClientMemberships:
                    let label = ClientMembershipIndicatorStatusEnum[indicator.data.ClientMembershipIndicatorStatus] || '';
                    return `${indicator.data.MembershipDisplayName} - ${this.$translate.instant("LABEL_TOOLTIP_MEMBERSHIP_" + label.toUpperCase())}`;
                case ClientIndicatorEnum.ClientPoints:
                    let remainingPoints = this.filterNumber(indicator.data.RemainingPoints);
                    return `${remainingPoints} ${this.$translate.instant("LABEL_POINTS")}`
                case ClientIndicatorEnum.ClientGiftCards:
                    let giftCardCount = indicator.data.GiftCard;
                    return `${giftCardCount} ${this.$translate.instant(giftCardCount === 1 ? "LABEL_CARD" : "LABEL_CARDS")}`;
                case ClientIndicatorEnum.ClientPackages:
                    let packageCount = indicator.data.Package;
                    let unlimitedPackageCount = indicator.data.UnlimitedPackage;
                    if (unlimitedPackageCount && unlimitedPackageCount > 0) {
                        return `${packageCount} ${this.$translate.instant(packageCount === 1 ? "LABEL_PASSIVE_ALERTS_PACKAGE_INCLUDING_UNLIMITED" : "LABEL_PASSIVE_ALERTS_PACKAGES_INCLUDING_UNLIMITED", { value: unlimitedPackageCount })}`;
                    } else {
                        return `${packageCount} ${this.$translate.instant(packageCount === 1 ? "LABEL_PASSIVE_ALERTS_PACKAGE" : "LABEL_PASSIVE_ALERTS_PACKAGES")}`;
                    }
                case ClientIndicatorEnum.ClientCancelledOrNoShowAppt:
                    let noShowCount = indicator.data.ClientCancelledOrNoShow;
                    return `${noShowCount} ${this.$translate.instant(noShowCount === 1 ? "LABEL_CANCEL_NOSHOW" : "LABEL_CANCEL_NOSHOWS")}`;
                case ClientIndicatorEnum.ClientTransworld:
                    return this.$translate.instant("LABEL_SENT_TO_TRANSWORLD");
                case ClientIndicatorEnum.ClientPaymentPlans:
                    let paymentPlans = indicator.data.Count;
                    return `${paymentPlans} ${paymentPlans == 1 ? this.$translate.instant("LABEL_PAYMENT_PLAN") : this.$translate.instant("HERO_SUB_PAYMENT_PLANS")}`;
                case ClientIndicatorEnum.ClientMinor:
                    return this.$translate.instant("LABEL_CLIENT_IS_CLIENT_IS_MINOR");
                case ClientIndicatorEnum.ClientRestricted:
                    return this.$translate.instant("LABEL_ISRESTRICTED");
                case ClientIndicatorEnum.ClientType:
                    return indicator.data.DisplayName;
                case ClientIndicatorEnum.ClientPaymentAccounts:
                    let activeCount = indicator.data.ActiveAccounts;
                    return `${activeCount} ${activeCount == 1 ?  this.$translate.instant("CLIENT_INDICATOR_11045494_PAYMENTACCOUNT") : this.$translate.instant("CLIENT_INDICATOR_11045494_PAYMENTACCOUNTS")}`
                case ClientIndicatorEnum.ClientAlerts:
                    let alertCount = indicator.alerts ? indicator.alerts.length : 0;
                    return `${alertCount} ${this.$translate.instant(alertCount === 1 ? "LABEL_ALERT" : "LABEL_ALERTS")}`;
                default:
                    return ClientIndicatorEnum[indicator.key] || null;
            }
        }

        $onChanges = (changes: ng.IOnChangesObject) => {

            if (changes.clientId && changes.clientId.previousValue && changes.clientId.currentValue && changes.clientId.previousValue !== changes.clientId.currentValue) {
                this.$onInit();
            }

            if (changes.peeks && changes.peeks.previousValue !== changes.peeks.currentValue) {
                this.togglePeeks();
            }

            if (changes.client && !changes.client.currentValue && changes.client.previousValue) {
                // subsections of data maintance screen tabs can null this out unexpectedly
                this.client = changes.client.previousValue;
            }

            if (changes.notes && changes.notes.isFirstChange() === false) {
                this.notifyOnChange();
            }
        }

    };


    angular.module('meevo.components.controls')
        .component('meevoClientIndicators', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/clientIndicators/clientIndicators.template.html',
            bindings: {
                clientId: '<',
                client: '<',
                notes: '<',
                showAll: '<',
                showPoints: '<',
                showMemberships: '<',
                showAccountBalance: '<',
                showPackages: '<',
                showGiftCards: '<',
                showCancelledOrNoShowAppt: '<',
                showTransworld: '<',
                showPaymentPlans: '<',
                showMinor: '<',
                showRestricted: '<',
                showType: '<',
                showPaymentAccounts: '<',
                showAlerts: '<',
                popups: '<',
                collapseable: '<',
                popupsLeftAlign: '<',
                peekEnabled: '=?',
                peekAlert: '=?',
                onIndicatorClick: '&',
                onCollapseClick: '&',
                onNoIndicatorsFound: '&',
                onChange: '&',
                hasAlert: '&?',
            },
            controller: [
                "meevo.AppSettings",
                "$rootScope",
                "$scope",
                "$translate",
                "$filter",
                "$timeout",
                "meevo.components.common.ClientIndicatorsDataService",
                "meevo.components.common.MembershipDetailsService",
                "meevo.components.common.SecurityService",
                "meevo.components.common.ClientMembershipDataService",
                "meevo.components.common.IdentityService",
                'meevo.plugins.paymentPlans.PaymentPlansApi',
                MeevoClientIndicatorsController
            ],
            controllerAs: 'vm'
        });

}
